<ng-container *ngIf="costCenterState$ | async as state">
    <h1 mat-dialog-title class="active">
        {{ (referenceValue.id ? 'app.dialog.edit-cost-center-reference-value.title.header' : 'app.dialog.add-cost-center-reference-value.title.header') | translate}}
    </h1>
    <div mat-dialog-content>
        <mat-generic-input
            [fields]="referenceValue.id ? layout.editFields : layout.addFields"
            (inputFormGroupChange)="onFormGroupChange($event)"
            [initialValue]="referenceValue">
        </mat-generic-input>
    </div>
    <div mat-dialog-actions>
        <button mat-stroked-button mat-dialog-close (click)="close(false)">{{ "app.button.cancel.label" | translate }}</button>
        <button [disabled]="!(dialogFieldsValid$ | async)" mat-flat-button color="primary" (click)="save()">{{ "app.button.save.label" | translate }}</button>
    </div>
</ng-container>
